import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { createUserServiceValidationForm } from '../../utils/validationSchema';
import Form from '../../layouts/Form';
import TextField from '../Reusable/Form/TextInput';
import NumberField from '../Reusable/Form/NumberField';

const CreateUser = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createUserServiceValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Username"}
          register={register("username")}
          errors={errors?.username}
        />
        <TextField
          label={"Email"}
          register={register("email")}
          errors={errors?.email}
        />
        <NumberField
          setValue={setValue}
          clearErrors={clearErrors}
          label={"Mobile Number"}
          register={register("mobile_number")}
          errors={errors?.mobile_number}
        />
        <TextField
          label={"Password"}
          register={register("password")}
          errors={errors?.password}
        />
        <TextField
          label={"Confirm Password"}
          register={register("confirm_password")}
          errors={errors?.password}
        />
      </div>
    </Form>
  )
}

export default CreateUser